class Sofatutor.Classes.VideoPlayerOverlays
  constructor: ->
    @$videoOverlay    = $('.js-video-player-overlay')
    @$playVideoButton = $('.js-play-video')

    @attachEventListeners()

  attachEventListeners: =>
    if @$videoOverlay.data('assigned-to-learning-group')
      if Sofatutor.player.videoJsLoaded()
        @player()?.one 'play', =>
          @player().pause()
          @$videoOverlay.show()
          Sofatutor.tracking.amplitude.track('lgstudents_assigned_content_hint_seen', @$videoOverlay.data('event-properties'))
      else
        @player()?.addEventListener 'play', ( =>
          @player().pause()
          @$videoOverlay.show()
          Sofatutor.tracking.amplitude.track('lgstudents_assigned_content_hint_seen', @$videoOverlay.data('event-properties'))
        ),once: true
      @$playVideoButton.on 'click', @playVideo
    else
      if Sofatutor.player.videoJsLoaded()
        @player()?.on 'play', =>
          @player()?.on 'ended', => @$playVideoButton.html(@$playVideoButton.data('wording-ended'))
          @player()?.on 'pause', => @$videoOverlay.show() unless @player()?.scrubbing()
      else
        @player()?.addEventListener 'ended', => @$playVideoButton.html(@$playVideoButton.data('wording-ended'))
        @player()?.addEventListener 'pause', => @$videoOverlay.show() unless @player()?.seeking
      @$playVideoButton.on 'click', @playVideo

  player: ->
    if Sofatutor.player.videoJsLoaded()
      if Sofatutor.player.isVideoJs5()
        videojs.getPlayers()['player-0']
      else
        videojs.players['player-0']
    else
      $('#player-0').get(0)

  playVideo: =>
    @$videoOverlay.hide()
    @$playVideoButton.html(@$playVideoButton.data('wording-continue'))
    @player()?.play()

$ ->
  return unless $('.js-video-player-overlay').length
  new Sofatutor.Classes.VideoPlayerOverlays()
